window.initializeSelect2 = function() {
    $('.select2').select2();
}

window.addEventListener('changeViewMode', function (data) {
    $('.view-mode')
        .removeClass('view-mode-create')
        .removeClass('view-mode-edit')
        .removeClass('view-mode-list')
        .removeClass('view-mode-monthly-productions')
        .addClass('view-mode-' + data.detail.mode);

    $('.view-mode .card-title').html(data.detail.page_title);

    let page_title = data.detail.page_title;

    if (typeof APP_NAME != 'undefined') {
        page_title = APP_NAME + ' | ' + data.detail.page_title;
    }

    $('head title').html(page_title);

    // Preserves the current pagination, search, and sorting while forcing a UI update.
    $('#datasetsTable').DataTable().draw(false);

    if (data.detail.current_page_url ?? null)
    {
        let newurl = data.detail.current_page_url;
        window.history.pushState({path: newurl}, page_title, newurl);
    }
})

//
// window.confirmAndEmitDeleteAction = function(...params) {
//
//     var c = confirm("Are you sure you want to delete this record? Action is irreversible.");
//
//     if (c == true) {
//
//         Livewire.emit(...params);
//     }
// }

// Sweet Alert 2
window.confirmAndEmitDeleteAction = function (...params) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            Livewire.emit(...params);
        }
    });
}


// Sweet Alert 2 | Success, Warning and Error Messages
// Do not forget to run `yarn dev` after update this file
document.addEventListener('DOMContentLoaded', function () {
    const showAlert = (title, text, icon) => {
        Swal.fire({
            title: title,
            text: text,
            icon: icon,
            confirmButtonText: 'OK'
        });
    };

    //general error
    Livewire.on('error', (errorMessage) => {
        showAlert('Error!', errorMessage, 'error');
    });

    //record not found
    Livewire.on('recordNotFound', (entity, entityId) => {
        showAlert('Not Found!', `${entity} with ID ${entityId} not found.`, 'warning');
    });

    //record saved
    Livewire.on('recordSaveSuccess', (entity, entityId) => {
        showAlert('Saved!', `${entity} with ID ${entityId} has been saved.`, 'success');
    });

    //record deleted
    Livewire.on('recordDeleteSuccess', (entity, entityId) => {
        showAlert('Deleted!', `${entity} with ID ${entityId} has been deleted.`, 'success');
    });

    //record save failed
    Livewire.on('recordSaveFailed', (entity, errorMessage, entityId) => {
        showAlert('Failed!', `${entity} with ID ${entityId} failed to save. Error: ${errorMessage}`, 'error');
    });

    //record delete failed
    Livewire.on('recordDeleteFailed', (entity, errorMessage, entityId) => {
        showAlert('Failed!', `${entity} with ID ${entityId} failed to delete. Error: ${errorMessage}`, 'error');
    });

    Livewire.on('recordWarning', (message) => {
        showAlert('Warning!', message, 'warning');
    });
});


window.confirmAndEmitEvent = function (...params) {
    let message = params.pop();
    console.log(params, message)

    var c = confirm(message);

    if (c == true) {

        Livewire.emit(...params);
    }
}

window.getAllValuesByElement = function (selector) {
    var values = [];
    if (typeof selector != 'Object') {

    }
    // $("input[name='directions']:checked")
    selector = $(selector);

    $.each(selector, function () {
        let type = $(this).attr('type');

        if ((type == 'checkbox' || type == 'radio') && !$(this).is(':checked')) {

            return;
        }

        values.push($(this).val());
    });

    console.log(values)

    return values;
}


window.scrollTo = function (scrollToElement, scrollToContainer, gap = 100) {
    if (!(scrollToElement instanceof jQuery)) {
        scrollToElement = $(scrollToElement);
    }

    if (scrollToElement.length === 0) {
        console.error('Invalid element passed to scrollTo:', scrollToElement);
        return;
    }

    if (!scrollToContainer) {
        scrollToContainer = $("html, body");
    } else if (!(scrollToContainer instanceof jQuery)) {
        scrollToContainer = $(scrollToContainer);
    }

    var position = scrollToElement.offset().top - scrollToContainer.offset().top;

    scrollToContainer.animate({scrollTop: position - gap}, "slow");
}

window.scrollToTop = function () {
    $("html, body").animate({scrollTop: 0}, "slow");
}
$(document).on('click', '.copy-btn', function () {
    $('[role="tooltip"] .tooltip-inner').html('Copied!')
})

window.addEventListener('pageChanged', function (event, data) {
    scrollToTop();
})

window.addEventListener('scrollTo', function (event, data) {

    event.detail = event.detail ?? null;

    _.debounce(function () {
        scrollToTop();

        if (event.detail == 'top') {
            scrollToTop();
        } else if (event.detail && $(event.detail).length > 0) {
            scrollToTop($(event.detail));
        } else if ($(".alert.alert-success:first").length > 0) {
            scrollTo($(".alert.alert-success:first"))
        } else if ($(".alert.alert-danger:first").length > 0) {
            scrollTo($(".alert.alert-danger:first"))
        } else if ($(".input-error:first").length > 0) {
            scrollTo($(".input-error:first"))
        }

    }, 100)();
})
